import { combineReducers } from 'redux';
import councils, * as dataSelectors from './regions';
import ui, * as uiSelectors from './ui';

const rootReducer = combineReducers({
  data: councils,
  ui: ui,
});

export default rootReducer;

export const getCouncils = (state) => dataSelectors.getCouncilsData(state.data);

export const getRegions = (state) => dataSelectors.getRegionsData(state.data);

export const getEntities = (state) => dataSelectors.getEntitiesData(state.data);

export const getQldCouncilsGeo = (state) =>
  dataSelectors.getQldCouncilsGeo(state.data);

export const getIsFetchingCouncils = (state) =>
  uiSelectors.getIsFetchingCouncils(state.ui);

export const getIsMobile = (state) => uiSelectors.getIsMobile(state.ui);

export const getActiveCouncil = (state) => {
  const activeCouncilId = uiSelectors.getActiveCouncil(state.ui);
  return activeCouncilId
    ? dataSelectors
        .getRegionsData(state.data)
        .find((council) => council.id === activeCouncilId)
    : null;
};

export const getActiveEntity = (state) => {
  const activeEntityId = uiSelectors.getActiveEntity(state.ui);
  return activeEntityId
    ? dataSelectors
        .getEntitiesData(state.data)
        .find((entity) => entity.id === activeEntityId)
    : null;
};

// export const getActiveRegion = state => {
//   const activeEntityId = uiSelectors.getActiveEntity(state.ui);
//   return activeEntityId
//     ? dataSelectors
//       .getEntitiesData(state.data)
//       .find(entity => entity.id === activeEntityId)
//     : null;
// };

export const getComparedCouncil = (state) => {
  const comparisonCouncilId = uiSelectors.getComparedCouncil(state.ui);
  return comparisonCouncilId
    ? dataSelectors
        .getRegionsData(state.data)
        .find((council) => council.id === comparisonCouncilId)
    : null;
};

export const getComparedEntity = (state) => {
  const comparisonEntityId = uiSelectors.getComparedEntity(state.ui);
  return comparisonEntityId
    ? dataSelectors
        .getEntitiesData(state.data)
        .find((entity) => entity.id === comparisonEntityId)
    : null;
};

export const getActivePage = (state) => uiSelectors.getActivePage(state.ui);



// WEBPACK FOOTER //
// ./src/reducers/index.js